import { FC, MouseEvent } from "react"
import MUIDialog, { DialogProps as MUIDialogProps } from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { Icon, IconColor } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"
import { ColorVariant } from "@/types/index"
import "./index.scss"

interface DialogProps extends MUIDialogProps {
   buttonTitle: string
   buttonColor?: ColorVariant
   isDisabled?: boolean
   titleTestId?: string
   buttonTestId?: string
   handleClose: (e: MouseEvent) => void
   handleButtonClick: (e: MouseEvent) => void
}

const Dialog: FC<DialogProps> = ({
   title,
   buttonTitle,
   buttonColor,
   open,
   isDisabled,
   titleTestId = TestId.DIALOG_TITLE,
   buttonTestId = TestId.DIALOG_BUTTON,
   handleClose,
   handleButtonClick,
}) => {
   return (
      <MUIDialog
         className="dialog"
         open={open}
         onClose={handleClose}
         sx={{ "& .MuiDialog-paper": { padding: "64px 32px 32px" } }}
      >
         <Icon
            className="dialog__close"
            name="cross"
            color={IconColor.COOL_GRAY}
            onClick={handleClose}
            data-testid={TestId.DIALOG_CLOSE}
         />
         <div
            className="dialog__title"
            data-testid={titleTestId}
         >
            {title}
         </div>
         <DialogActions sx={{ padding: "0" }}>
            <Button
               iconName="checkmark"
               iconPosition={ButtonIconPosition.LEFT}
               color={buttonColor}
               onClick={handleButtonClick}
               disabled={isDisabled}
               testId={buttonTestId}
            >
               {buttonTitle}
            </Button>
         </DialogActions>
      </MUIDialog>
   )
}

export default Dialog
